/* eslint-disable react-refresh/only-export-components -- a context's provider and its read hook belong together; the hook is not a component and has no Fast Refresh state to lose. */
import { createContext, useContext, type ReactNode } from 'react';
import type { IToast } from '@components/ui/Toasts/useToasts';

type PushToast = (toast: Omit<IToast, 'id'>) => void;

const LogisticsToastHostContext = createContext<PushToast | null>(null);

interface ILogisticsToastHostProps {
  push: PushToast;
  children: ReactNode;
}

/** The page's own toast stack, offered to the forms it hosts: a message
 *  raised just before a form closes (the stock save's area-move notice) must
 *  outlive the form, and a form-local stack unmounts with it. */
export function LogisticsToastHost({ push, children }: ILogisticsToastHostProps) {
  return <LogisticsToastHostContext value={push}>{children}</LogisticsToastHostContext>;
}

/** The page's `push`, or null outside the Logistics page. */
export function useLogisticsPageToast(): PushToast | null {
  return useContext(LogisticsToastHostContext);
}
